import { Component } from '@angular/core';
import { NavController, MenuController } from 'ionic-angular';
import { Auth } from '../../providers/auth';
import { LoadingController } from 'ionic-angular';
import { LoginPage } from '../login/login'; 
import { DisclaimerPage } from '../disclaimer/disclaimer'; 
import { ToastController } from 'ionic-angular';

// ---- COMMON MODULES ---- //
import { Functions } from '../../providers/functions';
import { TranslateService } from '@ngx-translate/core';
import { UserdataModel } from '../../providers/userdata-model';

@Component({
  selector: 'page-register',
  templateUrl: 'register.html',
  host: { '(window:resize)': 'handleResizeEvents($event)'}
})
export class RegisterPage {
  username: string;
  password: string;
  email: string;
  errorMessage: string;
  loader:any;
  iagree: boolean;
  fullname:string;
  sex:string;
  education:string;
  dob: string;
  loading: string;

  constructor(public functions: Functions, public rubedoSideMenu: MenuController, public userdataModel:UserdataModel, public toastCtrl: ToastController, public translate: TranslateService, public navCtrl: NavController, public auth: Auth, public loadingCtrl: LoadingController) {
    this.rubedoSideMenu = rubedoSideMenu;
    this.rubedoSideMenu.enable(false, 'rubedoSideMenu');
    this.functions.setSideMenuColorEnabled(false);
    translate.get('loading').subscribe(value => { this.loading = value;});
    
    this.errorMessage="";
    this.username="";
    this.password="";
    this.email="";
    this.iagree=false;
    this.fullname="";
    this.sex="";
    this.education="";
    this.dob="1980-04-11";
  }

  ionViewWillEnter(){
    //before the page in question becomes active
    this.functions.changeShowSidemenuButtonTo(false);
    this.dob=this.functions.getDateTodayYYYY_MM_DD();
  }

  ionViewDidEnter(){
    this.functions.setScaleForBigScreen();
  }

  handleResizeEvents(event: KeyboardEvent) {
    this.functions.setScaleForBigScreen();
  }

  goToLogin(){
    this.navCtrl.pop();
    //this.navCtrl.push(LoginPage, {});
  }

  goToDisclaimer(){
    this.navCtrl.push(DisclaimerPage, {});
  }

  register(){
    if(this.functions.deviceIsOnline()){
      this.presentLoading();
        this.auth.register(this.username,this.password,this.email,this.fullname,this.sex,this.dob,this.education,this.functions.language).then((response)=>{
          var responseString:string;
          responseString=response.toString();
          if(responseString.indexOf('RegisterResIsOk')!=-1){
            this.loader.dismiss();
            this.functions.showMessageTranslated(this.toastCtrl, "register_ok");
            this.navCtrl.setRoot(LoginPage, {});
           }else{
             //this.errorMessage=this.auth.errorMessage;
             this.functions.showMessage(this.toastCtrl, this.auth.errorMessage);
             this.loader.dismiss();
             return;
          }
        });
    }else{
      this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
    }
  }

  presentLoading() {
    this.translate.get('loading').subscribe(value => { 
      this.loader = this.loadingCtrl.create({
        content: value
      });
      this.loader.present();
    });
  }

  changeSetting(settingType,value){
    // Set settings in userdata is done here for in functions was not possibile due to circular reference problem
    switch (settingType) {
      case "language":
        this.userdataModel.setSettingsCurrentLanguage(this.functions.language);
        this.functions.setLanguage();
      break;
      default:
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/register/register.ts